import src from "IMAGE";
export default { src, width: 404, height: 247, blurWidth: 0, blurHeight: 0};
